if (!customElements.get("copy-code")) {
  customElements.define(
    "copy-code",
    class CopyCode extends HTMLElement {
      constructor() {
        super();
        this.copyButton = this.querySelector("button");
        // alert("copyButton", this.copyButton);
    }
    connectedCallback() {
        this.copyButton.addEventListener("click", this.handleCopy.bind(this));
        
      }
      handleCopy() {
        const code = this.getAttribute("data-code");
        if (code) {
          const text = code;
          navigator.clipboard.writeText(text).then(() => {
            this.copyButton.classList.add("copied");
            setTimeout(() => {
              this.copyButton.classList.remove("copied");
            }, 2000);
          });
        }
       
      }
    }
  );
}
